export const STATE_IDENTIFIER = {
  CALL_STATE: "callState",
};
